import React, { Component, Fragment } from 'react'
import { Translate } from '../../contexts/Language';
import { BreadCrumb, Card, Modal } from '../../components';
import { Config } from '../../config';
import { Service } from '../../services';
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../config/DataTableColumns';
import { ErrorMessage, ConfirmMessage, PortfolioMessage, Validator, VRules, VConditions } from '../../components/Validator';
import { createGlobalStyle } from 'styled-components';

export class trc20Wallet extends Component {
    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            dataTable: {
                columns: DataTableColumns.cryptoWalletTRC20,
                rows: []
            },
            subListTRC20: {
                columns: DataTableColumns.subListTRC20,
                rows: []
            },
            avaibleBalanceTRX: 0,
            avaibleBalanceUSDT: 0,
            avaibleSubBalanceTRX:0,
            avaibleSubBalanceUSDT:0,
            modal: false, 
            trc20submodal:false,
            trc20CommissionModal:false, 
            metaStatus:"",
            commissionFee:"",
            currentCommissionFee:"",
            commissionUpdateValidation: {  
                error: false,
                succsess:false,
                message: ''
            },
            searchTerm: '',
            validation: {
                error: false,
                message: ""
            },
            validation2: {
                error: true,
                message: ""
            },
            validation3: {
                error: true,
                message: ""
            },
            formData: {
                address: "",
                amount: 0,
                comment: "",
                authCode: ""
            }
        }
        this.handleCommissionChange = this.handleCommissionChange.bind(this);
        this.handleCommissionUpdate = this.handleCommissionUpdate.bind(this);
        this.onSave = this.onSave.bind(this);
        this.dataTableRows = [];
    }
    componentDidMount() {
        this.onDatatable();
    }
    onDatatable() {
        Config.utilities.loadingFetch();

        Service.CryptoService.ListTRC20().then(response => {

            if (response) {

                let dataTable = this.state.dataTable;

                dataTable.rows = response.list;
                this.dataTableRows = response.list

                this.setState({
                    dataTable: dataTable,
                    avaibleBalanceTRX: response.avaibleBalanceTRX,
                    avaibleBalanceUSDT: response.avaibleBalanceUSDT
                });

            }

            Config.utilities.loadingFetch();
        });
    }
     handleCommissionChange(event) {
        this.setState({ commissionFee: event.target.value });
    }

   
    handleCommissionUpdate(e) {
        e.preventDefault();

        const { commissionFee, metaStatus } = this.state; 

        // Loading animasyonunu başlat
        Config.utilities.loadingFetch();

        
        const data = {
            MetaStatus: metaStatus,          
            NewValue: commissionFee  
        };
        Service.CryptoService.Trc20CommissionFeeUpdate(data).then(response => {
            if (response) {
                this.setState(prevState => ({
                    
                    commissionUpdateValidation: { ...prevState.commissionUpdateValidation, error: false,succsess:true, message: 'Update to WREBATE Commission' },
                     
                }));                
            } else {
                this.setState(prevState =>({
                    commissionUpdateValidation: {...prevState.commissionUpdateValidation, error: true,succsess:false, message: 'Failed to update commission fee' }
                }));
            }
            
            Config.utilities.loadingFetch();
        });
    }

    
    GetCommissionFeeList() {

        // Servis üzerinden commission fee verilerini alıyoruz
        Service.CryptoService.Trc20CommissionFeeList().then(response => {
            if (response) {
                // Verileri state'e kaydediyoruz ve modalı açıyoruz
                this.setState(prevstate=>({
                    trc20CommissionModal: true,
                    currentCommissionFee: response.commissionFee,
                    metaStatus: response.metaStatus
                }));
            }
           
        })
    }

    onListSub() {
        Config.utilities.loadingFetch();
        Service.CryptoService.ListSubTRC20().then(response=> {
            if(response){
                this.setState(prevstate=>({ 

                        trc20submodal: true,
                        avaibleSubBalanceTRX: response.avaibleSubBalanceTRX,
                        avaibleSubBalanceUSDT: response.avaibleSubBalanceUSDT,
                        subListTRC20:{
                        ...prevstate.subListTRC20,
                        rows:response.subWalletsList
                    }
                 }))
            }
            Config.utilities.loadingFetch();
        })
    }
     
    onPortfolio() {
        Service.CryptoService.PortfolioTRC20(0).then(response => {
            //0 göndermemizin nedeni portfoloio-manager için limiti kaldırmak 
            if (response) {
                this.setState({

                    validation3: response

                });
                if (!response.error) {
                    /* this.setState({
                         modal: false
                     })*/
                    this.onDatatable();
                }
            }

        });
    }

    onFormChange(value, key) {

        let formData = this.state.formData;

        formData[key] = value;

        this.setState({
            formData
        });
    }
    onModal() {
        this.setState({
            modal: true
        });
    }
    isValid(data) {


        VRules["address"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Address can not be empty.")
        }
        VRules["comment"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Comment can not be empty.")
        }
        VRules["authCode"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Auth Code can not be empty.")
        }



        let error = Validator.Valid(data, this.Refs);

        this.setState({
            validation: error,
            validation2: error
        });

        return !error.error;
    }

    onSave() {
        if (this.isValid(this.state.formData)) {
            Config.utilities.loadingFetch();

            Service.CryptoService.CoinwithdrawTRC20(this.state.formData).then(response => {

                if (response) {
                    this.setState({
                        validation: response,
                        validation2: response
                    });
                    if (!response.error) {
                        /* this.setState({
                             modal: false
                         })*/
                        this.onDatatable();
                    }
                }

                Config.utilities.loadingFetch();
            });
        }

    }
    onSearch(login) {

        let filteredRows = [];
        if (login === "") {
            filteredRows = this.dataTableRows;
        }
        else {
            filteredRows = this.dataTableRows.filter(item => item.login === login);
        }
        if (filteredRows.length > 0) {
            let dataTable = this.state.dataTable;
            dataTable.rows = filteredRows;
            this.setState({
                dataTable
            });
        }

    }
    
    render() {
        return (
            <Fragment>
                <BreadCrumb Title={Translate("Wallet")} Name={Translate("Wallet")} />
                <PortfolioMessage Validation3={this.state.validation3} />
                <Card Title="TRC20 Main Wallet-TQBWv8itDpiuUfMzKJchCFfjNHXJg3JfoG" Description="USDT (TRC20) Transaction History">
                    {this.state.subListTRC20 && <Modal
                        Title={"TRC20 Sub Wallet List"}
                        Show={this.state.trc20submodal}
                        onClose={(e) => this.setState({ trc20submodal: false })} 
                        xlSize 
                    >
                        <div className="row">
                            <div className="col-md-6">
                                <div className="alert alert-success">
                                    <strong>Available SubBalance: </strong>
                                    <span>{this.state.avaibleSubBalanceTRX} TRX</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="alert alert-warning">
                                    <strong>Available SubBalance: </strong>
                                    <span>{this.state.avaibleSubBalanceUSDT} USDT</span>
                                </div>
                            </div>
                        </div>  
                        <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                            <input type="text" className="form-control col-md-2 mb-3" placeholder="Filter Login" onChange={(e) => this.setState({searchTerm: e.target.value})} />
                            {!Array.isArray(this.state.subListTRC20.rows) || this.state.subListTRC20.rows.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                </div> ) : 
                                ( <DataTable
                                    noHeader={true}
                                    columns={this.state.subListTRC20.columns}
                                    data={this.state.searchTerm.length > 0 ? 
                                        this.state.subListTRC20.rows
                                        .sort((a,b) => +a.login - +b.login)
                                        .filter(e => e.login.toString().includes(this.state.searchTerm)) : 
                                        this.state.subListTRC20.rows.sort((a,b) => +a.login - +b.login)}
                                    pagination
                                    highlightOnHover
                                />
                            )}
                        </div>
                    </Modal>}
                    <Modal Title={Translate("USDT (TRC20) Withdrawal")} Show={this.state.modal} onClose={(e) => this.setState({ modal: false })}>
                        <div className="row mt-1 mb-1">
                            <p className="text-muted mb-2 ml-1 col-md-12 font-12">USDT (TRC20) Withdrawal</p>
                            <div className="col-md-12">
                                <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                                    <ErrorMessage Validation={this.state.validation} />
                                    <ConfirmMessage Validation2={this.state.validation2} />
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="login" className="col-sm-4 col-form-label">Address</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="text" id="address" name="address" autoComplete="off" value={this.state.formData.address} onChange={(e) => this.onFormChange(e.target.value, "address")} />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="login" className="col-sm-4 col-form-label">Amount</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="number" id="amount" name="amount" autoComplete="off" value={this.state.formData.amount} onChange={(e) => this.onFormChange(e.target.value, "amount")} />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="login" className="col-sm-4 col-form-label">Comment</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="text" id="comment" name="comment" autoComplete="off" value={this.state.formData.comment} onChange={(e) => this.onFormChange(e.target.value, "comment")} />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="login" className="col-sm-4 col-form-label">Google Auth. Code</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="text" id="authCode" name="authCode" autoComplete="off" value={this.state.formData.authCode} onChange={(e) => this.onFormChange(e.target.value, "authCode")} />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="save-form" className="col-sm-4 col-form-label"></label>
                                        <div className="col-sm-8">
                                            <button type="button" className="btn btn-info float-right" onClick={(e) => this.onSave()}><i className="far fa-save mr-1"></i> Save Form</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal>
                    {this.state.trc20CommissionModal && (
                        <Modal
                        Title={`${this.state.metaStatus} ${Translate("Commission Update")}`}
                        Show={this.state.trc20CommissionModal}
                        onClose={() => this.setState({commissionFee:"" ,trc20CommissionModal: false ,commissionUpdateValidation: {error:false, succsess: false, message:""} })}
                    >
                        
                        <form onSubmit={this.handleCommissionUpdate}>
                            {/* MetaStatus Bilgisi */}
                            
                            <h5 style={{marginBottom: '1rem'}}>Current Commission Fee: {this.state.currentCommissionFee}</h5> 
    
                            {/* Commission Fee Düzenlenebilir Input */}
                            <div className="form-group">
                                <label htmlFor="commissionFee">Commission Fee</label>
                                <input id="commissionFee"
                                    type="number"
                                    required
                                    className="form-control"
                                    value={this.state.commissionFee}  // commissionFee inputu
                                    onChange={this.handleCommissionChange}   // Değer değiştikçe state güncellenir
                                />
                               
                            </div>
                           
                            {this.state.commissionUpdateValidation.error && (
                                <div className="alert alert-danger">
                                    {this.state.commissionUpdateValidation.message}
                                </div>
                            )}

                             {this.state.commissionUpdateValidation.succsess && (
                                <div className="alert alert-success">
                                    {this.state.commissionUpdateValidation.message}
                                </div>
                            )}
    
                            <button className="btn btn-primary" type="submit">
                                Update Commission Fee
                            </button>
                        </form>
                    </Modal>
                    )}

                    <div className="row">

                        <div className="col-md-3">
                            <div class="alert alert-success">
                                <strong>Available Balance: </strong>
                                <span>{this.state.avaibleBalanceTRX} TRX</span>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div class="alert alert-warning">
                                <strong>Available Balance: </strong>
                                <span>{this.state.avaibleBalanceUSDT} USDT</span>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className=" d-flex justify-content-end">
                                <button type="button" className="btn btn-warning add-new-button tabless ml-1" onClick={() => this.GetCommissionFeeList()} ><i className="fas fa-coins mr-3" ></i>Commission Update</button>
                                <button type="button" className="btn btn-success add-new-button tabless ml-1" onClick={() => this.onListSub()} ><i className="fas fa-coins mr-3" ></i>TRC20 Sub Wallet List</button>
                                <button type="button" className="btn btn-danger  add-new-button tabless ml-1 " onClick={(e) => this.onModal()}><i className="fas fa-coins mr-1"></i> USDT (TRC20) Withdrawal</button>
                                <button type="button" className="btn btn-dark  add-new-button tabless ml-1" onClick={(e) => this.onPortfolio()}><i className="fas fa-coins mr-1"></i> TRC20 Manuel Tetikleme</button>
                            </div>

                            <input type="text" className="form-control col-md-2 mb-3" placeholder="Filter Login" onChange={(e) => this.onSearch(e.target.value)} />
                            {!Array.isArray(this.state.dataTable.rows) || this.state.dataTable.rows.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                </div>) :
                                (<DataTable
                                    noHeader={true}
                                    columns={this.state.dataTable.columns}
                                    data={this.state.dataTable.rows}
                                    pagination
                                    highlightOnHover />)}
                        </div>
                    </div>
                </Card>
            </Fragment>)
    }
}